import React, { useState } from 'react';
import { Div, Span, ColDiv } from 'styles';
import * as S from './InputStyle';

export function FormikInput({
  name,
  value,
  onChange,
  type,
  label,
  subLabel,
  disabled,
  helperText,
  error,
  unit,
  $default,
  $flex,
  $invalid,
  $touch,
  $invalidText,
  ...props
}) {
  const [tempType, setTempType] = useState(type || 'text');

  return (
    <ColDiv $flex={$flex}>
      {label && (
        <S.Label $default={$default} $disabled={disabled}>
          {label}
          {subLabel && (
            <Span $marginLeft={8} $color={disabled ? 'disabled' : 'primary700'} $type="m">
              {subLabel}
            </Span>
          )}
        </S.Label>
      )}
      <Div $position="relative">
        <S.InputField
          name={name}
          value={value}
          type={tempType !== 'tel' ? tempType : 'text'}
          onChange={onChange}
          disabled={disabled}
          aria-invalid={$touch ? ($invalid ? 'true' : '') : null}
          {...props}
        />
        {unit && <S.Unit $disabled={disabled}>{unit}</S.Unit>}
      </Div>
      {$touch && $invalid && <S.HelperText>{$invalidText}</S.HelperText>}
    </ColDiv>
  );
}